// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.icon-return {
  cursor: pointer;
}
.center {
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}
*:focus {
  outline: none;
}
.woot-widget-bubble {
  bottom: 40px !important;
  z-index: 1 !important;
  width: 50px !important;
  height: 50px !important;
  display: flex !important;
  justify-content: center !important;
  align-items: center !important;
}
.chatwoot-container {
  margin-bottom: 20px;
}
#woot-widget-bubble-icon {
  margin: 15px !important;
}
.woot--close::before,
.woot--close::after {
  left: 24px !important;
  top: 14px !important;
}
.custom-confirm-width {
  width: 580px !important; /* 设置你需要的宽度 */
  max-width: 95% !important; /* 确保在移动端不会溢出 */
}
`, "",{"version":3,"sources":["webpack://./src/assets/styles/global.css"],"names":[],"mappings":"AAAA;EACE,eAAe;AACjB;AACA;EACE,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,aAAa;AACf;AACA;EACE,uBAAuB;EACvB,qBAAqB;EACrB,sBAAsB;EACtB,uBAAuB;EACvB,wBAAwB;EACxB,kCAAkC;EAClC,8BAA8B;AAChC;AACA;EACE,mBAAmB;AACrB;AACA;EACE,uBAAuB;AACzB;AACA;;EAEE,qBAAqB;EACrB,oBAAoB;AACtB;AACA;EACE,uBAAuB,EAAE,aAAa;EACtC,yBAAyB,EAAE,eAAe;AAC5C","sourcesContent":[".icon-return {\n  cursor: pointer;\n}\n.center {\n  height: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n*:focus {\n  outline: none;\n}\n.woot-widget-bubble {\n  bottom: 40px !important;\n  z-index: 1 !important;\n  width: 50px !important;\n  height: 50px !important;\n  display: flex !important;\n  justify-content: center !important;\n  align-items: center !important;\n}\n.chatwoot-container {\n  margin-bottom: 20px;\n}\n#woot-widget-bubble-icon {\n  margin: 15px !important;\n}\n.woot--close::before,\n.woot--close::after {\n  left: 24px !important;\n  top: 14px !important;\n}\n.custom-confirm-width {\n  width: 580px !important; /* 设置你需要的宽度 */\n  max-width: 95% !important; /* 确保在移动端不会溢出 */\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
